import Vue from 'vue'
import axios from 'axios'
import { baseURL } from '../config'
// 配送单预览
export const newPOrder = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 仓库添加商品
export const getWarehouseFrom = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 配送单-保存(临时保存/正式保存
export const addDistribution = (token, data) => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=orderapi&str=addDistribution&token=" + token, data)
//获取地址
export const getAddress = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 验证地址
export const addAddress1 = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 修改配送单提交
export const updateDistribution = (token, data) => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=orderapi&str=updateDistribution&token=" + token, data)
// 上传发货附件文件
export const updateDeliveryOrderFile = data => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=updateDeliveryOrderFile&token=" + localStorage.getItem('token'), data)


